import { HIDE_MODAL, MODAL_SKIP_BUTTON_ADS, showModal } from '../../../../actions/modal';
import store from '../../../../store';

export const closeSkipButtonAds = () => {
    store.dispatch(
        showModal({
            modalType: HIDE_MODAL,
            modalProps: {},
        })
    );
};

export const showSkipButtonAds = () => {
  const { playerstate = "" } = store.getState().player;
  playerstate === "PLAYING" &&
    store.dispatch(
        showModal({
            modalType: MODAL_SKIP_BUTTON_ADS,
            modalProps: {},
        })
    );
};



// WEBPACK FOOTER //
// ./src/devices/all/bitmovin/utils/skipButton.js